import styled from '@emotion/styled';

export const FilterBarRoot = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.25rem',
});

export const DateRangeRow = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
});

export const QuickPickWrap = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.35rem',
});

export const StatusToggleRow = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  flexWrap: 'wrap',
  color: theme.palette.text.primary,
  '& .MuiToggleButtonGroup-root': {
    width: '100%',
  },
  '& .MuiToggleButton-root': {
    flex: 1,
    fontSize: '0.75rem',
    padding: '4px 8px',
    textTransform: 'none',
    lineHeight: 1.4,
  },
}));
